import { startCase } from 'lodash';

import {
  DOMAIN_PAGE_SEARCH_FILTERS,
  NUMBER_OF_RESULTS_PER_PAGE,
  SEARCH_FILTERS,
} from 'bundles/enterprise-learner-search/constants';
import { SEARCH_MAIN_INDEX_ID } from 'bundles/search-common/constants';
import type { SearchConfig, SearchContext } from 'bundles/search-common/providers/searchTypes';

type options = {
  searchContext?: SearchContext;
  shouldEnableShortFormContent?: boolean;
  facets?: string[];
  facetFilters?: string[][];
  shouldSyncFiltersWithUrl?: boolean;
  limit?: number;
};

export const FacetFiltersForExcludingSFC = [
  ['productTypeDescription:-Short Form Content Video'],
  ['productTypeDescription:-Short Form Content Lesson'],
];

const enterpriseIndexConfig = (options: options = {}): SearchConfig[] => {
  const { searchContext, shouldEnableShortFormContent, facets = SEARCH_FILTERS } = options;
  const facetFilters = options.facetFilters ?? (shouldEnableShortFormContent ? undefined : FacetFiltersForExcludingSFC);
  const shouldSyncFiltersWithUrl = options.shouldSyncFiltersWithUrl ?? true;
  const limit = options.limit ?? NUMBER_OF_RESULTS_PER_PAGE;

  return [
    {
      id: SEARCH_MAIN_INDEX_ID,
      entityType: 'PRODUCTS',
      searchContext,
      limit,
      facets,
      facetFilters,
      syncQueryWithUrl: true,
      syncFiltersWithUrl: !!shouldSyncFiltersWithUrl,
      sortBy: 'BEST_MATCH',
    },
  ];
};

type domainOptions = options & { domainId?: string; subdomainId?: string };

export const enterpriseDomainsIndexConfig = (options: domainOptions = {}): SearchConfig[] => {
  const { searchContext, shouldEnableShortFormContent, domainId, subdomainId } = options;
  const facetFilters = shouldEnableShortFormContent ? [] : [...FacetFiltersForExcludingSFC];
  if (domainId) facetFilters.push([`topic:${startCase(domainId)}`]);
  if (subdomainId && !subdomainId.includes('all-')) facetFilters.push([`subtopic:${startCase(subdomainId)}`]);

  return [
    {
      id: SEARCH_MAIN_INDEX_ID,
      entityType: 'PRODUCTS',
      searchContext,
      limit: 10,
      facets: DOMAIN_PAGE_SEARCH_FILTERS,
      facetFilters,
    },
  ];
};

export default enterpriseIndexConfig;
